const hasActiveFilter = (searchQueryParams?: URLSearchParams, searchFilterFields: string[] = []) => {
  const search = searchQueryParams?.get('search') ?? '';

  if (!search) {
    return false;
  }

  if (!searchFilterFields.length) {
    return true;
  }

  return search.split(';').some((item) => {
    const [key, value] = item.split(':');

    return Boolean(value) && searchFilterFields.includes(key);
  });
};

export default hasActiveFilter;
